<template>
  <v-app-bar
    app
    :class="{ 'app-bar-mobile': windowWidth < 768 }"
    :color="windowWidth < 768 ? 'primary' : ''">
    <v-btn
      v-if="windowWidth >= 768 && iconBack"
      icon>
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <v-app-bar-nav-icon
      v-if="windowWidth < 768"
      @click="update(true)" />
    <v-toolbar-title>CAMP FULFILLMENT</v-toolbar-title>
    <v-spacer />

    <v-toolbar-items
      v-if="windowWidth >= 768"
      id="select-warehouse">
      <label class="mr-2 mb-1">สาขา : </label>
      <v-select
        :value="selectedWarehouse"
        :items="warehouses"
        item-text="campWarehouse"
        item-value="sellsukiWarehouse"
        placeholder="เลือกสาขา"
        @change="selectEmit" />
    </v-toolbar-items>

    <template
      v-if="windowWidth < 768"
      v-slot:extension>
      <v-toolbar-items id="select-warehouse">
        <label class="mr-2">สาขา : </label>
        <v-select
          :value="selectedWarehouse"
          :items="warehouses"
          item-text="campWarehouse"
          item-value="sellsukiWarehouse"
          placeholder="เลือกสาขา"
          @change="selectEmit" />
      </v-toolbar-items>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    windowWidth: {
      type: Number,
      required: true
    },
    backIcon: {
      type: Boolean,
      required: false,
      default: true
    },
    iconBack: {
      type: Boolean,
      required: false,
      default: false
    },
    warehouses: {
      type: Array,
      required: true,
      default: () => []
    },
    selectedWarehouse: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      selectWarehouse: ''
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    },
    selectEmit (value) {
      this.$emit('warehouse', value)
    }
  }
}
</script>

<style>
#select-warehouse,
#select-warehouse .v-input {
  display: flex;
  align-items: center;
}
#select-warehouse .v-input {
  width: 150px;
  margin-bottom: -5px;
}
#select-warehouse .v-text-field__details {
  display: none;
}
@media screen and (max-width: 767px) {
  #select-warehouse {
    width: 100%;
  }
}
</style>
